import { defineLocalStore } from '@/utils/localStore'
import { computed } from 'vue'

type AssignmentHistoryRow = {
  id: number | string
  position: string
  department: string
  dateFrom?: string
  dateTo?: string
  status?: string
}

export const {
  useLocalStore: useUserCardHistoryStore,
  initLocalStore: initUserCardHistoryStore,
} = defineLocalStore('userCardHistory', (core: any) => {
  const assignmentHistory = computed<AssignmentHistoryRow[]>(() => {
    return ((core.user as any).assignmentHistory ?? []).map((a: any) => ({
      id: a.id,
      position: a.position ?? '—',
      department: a.department ?? '—',
      dateFrom: a.dateFrom,
      dateTo: a.dateTo,
      status: a.status,
    }))
  })

  return {
    assignmentHistory,
  }
})
